import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { analyticsKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';
import type { TopAccountsParams } from '@/types/api';

export function useTopAccounts(params: TopAccountsParams = {}) {
  return useQuery({
    queryKey: analyticsKeys.topAccounts(params),
    queryFn: () => analyticsApi.topAccounts(params),
    staleTime: STALE_TIMES.long,
    gcTime: GC_TIMES.long,
  });
}
